import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { NotificationsService } from '@services/notifications.service';
import {
  loadNotifications,
  loadNotificationsFailure,
  loadNotificationsSuccess,
} from '@store/notifications/notifications.actions';

@Injectable()
export class NotificationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly notificationsService = inject(NotificationsService);

  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNotifications),
      exhaustMap(() =>
        this.notificationsService.list().pipe(
          map((notifications: any) => {
            return loadNotificationsSuccess({ list: notifications });
          }),
          catchError((error) =>
            of(loadNotificationsFailure({ error: error?.message || String(error) })),
          ),
        ),
      ),
    ),
  );
}
